require('assets/global.scss')
require('../common.scss')

require('../../module/header/header.scss')
require('../../module/header/header.js')
require('../../module/passport-header/passport-header.scss')
require('../../module/passport-header/passport-header.js')

require('../../module/passport-password/passport-password.scss')
require('../../module/passport-password/passport-password.js')
require('../../module/footer/footer.scss')
require('../../module/footer/footer.js')



// WEBPACK FOOTER //
// ./src/page/passport-password/page.js